import { useToggleWithNavigation } from '../../hooks';
import { useOnEscapeKey } from '../../hooks/useOnEscapeKey';
import { useToggleWithAnimation } from '../../hooks/useToggleWithAnimation';
import { UseModalArgs, UseModalReturn } from './types';

const noop = () => undefined;

export const useModal = ({
  escapeKeyEnabled = false,
}: UseModalArgs = {}): UseModalReturn => {
  const { isOpen, open, close } = useToggleWithNavigation();
  const toggleWithAnimationProps = useToggleWithAnimation({ isOpen });
  useOnEscapeKey(escapeKeyEnabled ? close : noop);

  return {
    modalProps: {
      ...toggleWithAnimationProps,
      onClose: close,
    },
    open,
    close,
  };
};
